import { Link, Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import ThemeToggle from "./ThemeToggle.jsx";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0 }); }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">

      {/* //header */}

      <header className="sticky top-0 z-10 border-b border-line bg-ink/90 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center gap-3 px-4 py-3">

          <Link to="/" className="flex items-center gap-3 focus-visible:outline-2 focus-visible:outline-glow">
            {/* LOGO: yahan <img src={logo} /> laga dena */}
            <span className="grid size-10 place-items-center rounded-full bg-glow font-display text-lg font-extrabold text-ink">TV</span>
            <span className="font-display text-2xl font-bold tracking-tight">TV Show<span className="opacity-50">:2</span></span>
          </Link>

          <ThemeToggle />     { /*ye black white mode hai */}
        </div>
      </header>

      {/* ads */}
     

      <main key={pathname} className="page-enter mx-auto w-full max-w-5xl flex-1 px-4 py-8 sm:py-12">
        <Outlet />
      </main>

      <footer className="border-t border-line px-4 py-8 text-center text-sm text-mist">
        © {new Date().getFullYear()} TV Show. All rights reserved.
      </footer>
    </div>

  );
}


